const GRID_COLUMN_STYLE_PROPS_DATA = {
  gridColumn: { type: "identity", property: "gridColumn" },
  gridColumnEnd: { type: "identity", property: "gridColumnEnd" },
  gridColumnStart: { type: "identity", property: "gridColumnStart" }
};

export { GRID_COLUMN_STYLE_PROPS_DATA };
